import { render, staticRenderFns } from "./table_manage.vue?vue&type=template&id=b72b7378&scoped=true"
import script from "./table_manage.vue?vue&type=script&lang=js"
export * from "./table_manage.vue?vue&type=script&lang=js"
import style0 from "./table_manage.vue?vue&type=style&index=0&id=b72b7378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72b7378",
  null
  
)

export default component.exports